// Polyfill for Set.prototype.difference
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Set/difference
if (!Set.prototype.difference) {
  Set.prototype.difference = function (other) {
    const result = new Set(this)
    for (const elem of other) {
      result.delete(elem)
    }
    return result
  }
}
